import React from "react";
import _ from "lodash";
import Select from "react-select";
import { DATE_RANGE_TYPE } from "components/playground/home-dashboard-v2/DateHelper";
import DateRangePicker from "components/common/DateRangePicker";
import InventoryFilter from "components/playground/common/InventoryFilter";
import RequestTypeFilter from "./RequestTypeFilter";

const fixedWidthStyle = { maxWidth: "1280px", margin: "auto" };

class YbMockupHomeTopFilterHeader extends React.Component {
  constructor(props) {
    super(props);

    const dateRangeType = DATE_RANGE_TYPE.THIS_MONTH;
    const { startDate, endDate } = props;

    this.state = {
      dateRangeType,
      startDate,
      endDate,
    };

    this.child = React.createRef();
    this.handleClosePopover = this.handleClosePopover.bind(this);
  }

  handleClosePopover() {
    this.child.current.handleClosePopup();
  }

  render() {
    const {
      isReseller,
      publishers,
      selectedPubId,
      networks,
      selectedNetworkId,
      handleInventoryFilterChanged,
      yieldSets,
      selectedYieldSetIds,
      selectedCurrency,
      currencies,
      handleCurrencyChanged,
      requestTypes,
      selectedRequestType,
      handleRequestTypeChanged,
      startDate,
      endDate,
    } = this.props;
    return (
      <>
        <div className="bg-gray-200 px-12 py-2">
          <div className="flex justify-between" style={fixedWidthStyle}>
            <div className="flex">
              <InventoryFilter
                isReseller={isReseller}
                publishers={publishers}
                selectedPubId={selectedPubId}
                networks={networks}
                selectedNetworkId={selectedNetworkId}
                selectedYieldSetIds={selectedYieldSetIds}
                handleInventoryFilterChanged={handleInventoryFilterChanged}
                yieldSets={yieldSets}
              ></InventoryFilter>

              <div className="mx-2">
                <DateRangePicker
                  startDate={startDate}
                  endDate={endDate}
                  handleDateRangeChanged={
                    this.props.handleDateRangeFilterChanged
                  }
                ></DateRangePicker>
              </div>

              <div className="mr-2">
                <RequestTypeFilter
                  requestTypes={requestTypes}
                  selectedRequestType={selectedRequestType}
                  handleRequestTypeChanged={handleRequestTypeChanged}
                ></RequestTypeFilter>
              </div>
            </div>

            <CurrencySelector
              currencies={currencies}
              selectedCurrency={selectedCurrency}
              handleCurrencyChanged={handleCurrencyChanged}
            ></CurrencySelector>
          </div>
        </div>
      </>
    );
  }
}

class CurrencySelector extends React.PureComponent {
  constructor(props) {
    super(props);

    const options = _.map(props.currencies, (c) => {
      return { value: c, label: c };
    });

    const selectedValue = _.find(options, { value: props.selectedCurrency });

    this.state = {
      options,
      selectedValue,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(option) {
    this.setState({
      selectedValue: option,
    });

    this.props.handleCurrencyChanged(option.value);
  }

  render() {
    const { options, selectedValue } = this.state;

    return (
      <>
        <Select
          className="z-50 w-24"
          defaultValue={selectedValue}
          value={selectedValue}
          onChange={this.handleChange}
          options={options}
          isSearchable={false}
        />
      </>
    );
  }
}

export default YbMockupHomeTopFilterHeader;
